import { render } from "./Verzenden.vue?vue&type=template&id=023b4c82"
import script from "./Verzenden.vue?vue&type=script&lang=js"
export * from "./Verzenden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__